import type { IPromiseBasedObservable } from 'mobx-utils'
import { fromPromise } from 'mobx-utils'

export function initStatus(): IPromiseBasedObservable<unknown> {
    return fromPromise.resolve()
}
